import React from 'react';

const PRINCIPLES = [
  'Operations-first',
  'Engineered for scale',
  'Customer-loop by default',
  'API-first',
  'Privacy-respecting',
];

const Partners = ({ label = 'Designed with a few simple principles' }) => (
  <div className="cp-partners">
    <div className="cp-partners-label">{label}</div>
    <div className="cp-partners-row">
      {PRINCIPLES.map((p) => (
        <span className="cp-partner" key={p}>{p}</span>
      ))}
    </div>
  </div>
);

export default Partners;
